import { registerMapper } from './register.js';

registerMapper('courses', (item) => {
    var _a, _b, _c, _d;
    const title = (_a = item.title) !== null && _a !== void 0 ? _a : '';
    const courseType = (_b = item.courseType) !== null && _b !== void 0 ? _b : '';
    const learnerTime = item.learnerTime && item.learnerTime !== 'Not Informed'
        ? item.learnerTime
        : '';
    const cardMeta = courseType && learnerTime
        ? `${courseType} - ${learnerTime}`
        : courseType || learnerTime;
    return {
        title,
        meta: cardMeta,
        description: (_c = item.description) !== null && _c !== void 0 ? _c : '',
        imageSrc: item.imageUrl,
        imageAlt: title,
        tags: Array.isArray(item.tags) ? item.tags : [],
        modalPrimaryCtaLabel: item.enrollNowText,
        modalPrimaryCtaLink: (_d = item.link) !== null && _d !== void 0 ? _d : '',
        modalSecondaryCtaLabel: item.registerLabelText,
        modalSecondaryCtaLink: item.registerAbsorbUrl,
    };
});
